import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

// Página para endereços inexistentes: o "noindex" impede que o Google a indexe
export default function NaoEncontrada({ mensagem = "Página não encontrada." }) {
  return (
    <div className="container py-5">
      <Helmet>
        <title>Página não encontrada | Psicóloga Elaine Rampazzo</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <h1 className="h2 text-marrom-suave">{mensagem}</h1>

      <div className="d-flex gap-2 mt-3">
        <Link to="/" className="btn btn-outline-secondary">
          Ir para o início
        </Link>
        <Link to="/blog" className="btn btn-outline-success">
          Ver o blog
        </Link>
      </div>
    </div>
  );
}
